/* Original enhancement around Shopify's native product form; no custom checkout API. */
(() => {
  if (customElements.get('rivonella-native-checkout')) return;
  class RivonellaNativeCheckout extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.form = this.closest('form');
      this.scope = this.closest('section[data-product-handle]') || this.closest('.shopify-section');
      this.button = this.querySelector('[data-rv-checkout]');
      this.addButton = this.form?.querySelector('[name="add"]');
      this.pending = false;
      this.submitting = false;
      if (!this.form || !this.button || !this.addButton) return;
      const options = { signal: this.events.signal };
      this.scope.addEventListener('change', (event) => {
        if (event.target.closest('variant-selects')) {
          this.pending = true;
          this.sync();
        }
      }, { ...options, capture: true });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.addButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data?.sectionId) !== this.dataset.sectionId) return;
          this.pending = false;
          this.sync();
        });
      }
      this.form.addEventListener('submit', (event) => {
        if (!event.submitter?.hasAttribute('data-rv-checkout')) return;
        this.sync();
        if (this.button.disabled || this.submitting) {
          event.preventDefault();
          return;
        }
        this.submitting = true;
        this.button.setAttribute('aria-busy', 'true');
        // Do not disable the submitter: its name/value supplies Shopify's return_to parameter.
      }, options);
      window.addEventListener('pageshow', () => {
        this.submitting = false;
        this.button.removeAttribute('aria-busy');
        this.sync();
      }, options);
      this.sync();
    }

    sync() {
      if (!this.button || !this.addButton) return;
      const id = this.form.querySelector('input[name="id"]')?.value;
      this.button.disabled = this.pending || !id || this.addButton.disabled || this.addButton.getAttribute('aria-disabled') === 'true';
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.unsubscribe?.();
      this.events = null;
    }
  }
  customElements.define('rivonella-native-checkout', RivonellaNativeCheckout);
})();
